import React from 'react';
import PropTypes from 'prop-types';
import { formatMessage, FormattedMessage } from 'translate';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import { List } from 'immutable';
import clsx from 'clsx';
import TwoKeyStorage from '../../../../_core/2KeyStorage';
import StyledPayItForward from './styles/PayItForward.styles';

import { CampaignActions, CampaignSelectors, userSelectors } from '../../../../_redux';
import AppContext from '../../../../context';

import { CAMPAIGN_TYPES } from '../../../../constants/campaign';
import { isInAppBrowser } from '../../../../_core/utils';
import CloseIcon from '../../../../icons/wallet/close-white.svg';
import LeftHandMobileIcon from '../../../../icons/pay-it-forward/give_Scroll_Mobile.svg';
import LeftHandIcon from '../../../../icons/pay-it-forward/give_Scroll_Deskop.svg';
import RightHandMobileIcon from '../../../../icons/pay-it-forward/Take_Hand_Mobile.svg';
import RightHandIcon from '../../../../icons/pay-it-forward/Take_Hand_Desktop.svg';
import { INCENTIVE_MODELS } from '../../../../constants';


import ManualReward from './ManualReward';
import HowItWorks from './HowItWorks';
import LinkGeneration from './LinkGeneration';

import ManualIcon from '../../../../icons/pay-it-forward/manual.svg';
import ManualBg from '../../../../icons/pay-it-forward/manual_desktop.svg';
import EqualIcon from '../../../../icons/pay-it-forward/equal.svg';
import EqualBg from '../../../../icons/pay-it-forward/equal_desktop.svg';
import Equal3xIcon from '../../../../icons/pay-it-forward/equal_3x.svg';
import Equal3xBg from '../../../../icons/pay-it-forward/equal_3x_desktop.svg';
import GrowingIcon from '../../../../icons/pay-it-forward/growing.svg';
import GrowingBg from '../../../../icons/pay-it-forward/growing_desktop.svg';
import SignAndLogin from './SignAndLogin';
import ForwardRopstenHeader from './ForwardRopstenHeader';
import TargetAudience from './TargetAudience';
import { ActionButton, CurrencyFormatter } from '../../../_common';
import { getSearchParams, setSearchParams } from '../../../../_core/queryparams';
import { ipfsFromQuery } from '../../../../constants/regex';

const SharingTypes = {
  MANUAL: { img: ManualIcon, bgImg: ManualBg },
  VANILLA_AVERAGE: { img: EqualIcon, bgImg: EqualBg },
  VANILLA_AVERAGE_LAST_3X: { img: Equal3xIcon, bgImg: Equal3xBg },
  VANILLA_POWER_LAW: { img: GrowingIcon, bgImg: GrowingBg },
  NO_REFERRAL_REWARD: { img: ManualIcon, bgImg: GrowingBg },
};

const campaignTypeHeader = {
  [CAMPAIGN_TYPES.tokens]: (
    <FormattedMessage id="campaign_conversions.participated" />
  ),
  [CAMPAIGN_TYPES.donation]: (
    <FormattedMessage id="main.donation" />
  ),
  [CAMPAIGN_TYPES.webinar]: (
    <FormattedMessage id="campaign_pay_it_forward.referral_reward_from_purchases" />
  ),
};

const rewardTitle = {
  [CAMPAIGN_TYPES.contentViews]: 'referral_reward_per_click',
  [CAMPAIGN_TYPES.tokens]: 'referral_reward',
  [CAMPAIGN_TYPES.donation]: 'referral_reward',
  [CAMPAIGN_TYPES.webinar]: 'referral_reward_webinar',
};

const mapStateToProps = state => ({
  referralLinks: CampaignSelectors.campaignLinksSelector(state),
  maximumReferralReward: state.campaign.get('maximumReferralReward'),
  userId: state.user.getIn(['userMetadata', 'id']),
  user: state.user.get('userMetadata'),
  isLoading: state.campaign.get('joiningCampaign') || state.campaign.get('campaignLoading'),
  enums: state.enums.get('enums', { Country: { Country: { name_to_value: {} } } }),
  isEmailVerificationRequired: userSelectors.isEmailVerificationRequired(state),
});

const mapDispatchToProps = {
  OPEN_PAY_IT_FORWARD_MODAL: CampaignActions.OPEN_PAY_IT_FORWARD_MODAL,
  SET_LOGIN_REQUIRED_MODAL: CampaignActions.SET_LOGIN_REQUIRED_MODAL,
  TOGGLE_FEEDBACK_MODAL: CampaignActions.TOGGLE_FEEDBACK_MODAL,
  CREATE_CAMPAIGN_FEEDBACK: CampaignActions.CREATE_CAMPAIGN_FEEDBACK,
  SET_CAMPAIGN_ACCESS_ERROR: CampaignActions.SET_CAMPAIGN_ACCESS_ERROR,
  CHECK_FEEDBACK_STATE: CampaignActions.CHECK_FEEDBACK_STATE,
  OPEN_HOW_IT_WORKS_MODAL: CampaignActions.OPEN_HOW_IT_WORKS_MODAL,
  CHECK_UNCOMPLETED_CONVERSIONS: CampaignActions.CHECK_UNCOMPLETED_CONVERSIONS,
  JOIN_CAMPAIGN: CampaignActions.JOIN_CAMPAIGN,
  PUSH: push,
};

const PayItForwardMessages = ({
  manual_title: { id: 'main.manual_uc' },
  vanilla_average_title: { id: 'main.equal_uc' },
  vanilla_average_last_3x_title: { id: 'main.equal_+_3x' },
  vanilla_power_law_title: { id: 'main.growing' },
  manual_description: { id: 'campaign_pay_it_forward.manual_description' },
  vanilla_average_description: { id: 'campaign.vanilla_average_desc' },
  vanilla_average_last_3x_description: {
    id: 'campaign.vanilla_average_last_3x_desc',
  },
  vanilla_power_law_description: { id: 'campaign.vanilla_power_law_desc' },
  referral_reward_per_click: {
    id: 'campaign_pay_it_forward.referral_reward_per_click',
  },
  referral_reward_per_click_hedge: {
    id: 'campaign_pay_it_forward.referral_reward_per_click_hedge',
  },
  referral_reward: { id: 'campaign_pay_it_forward.referral_reward' },
  referral_reward_webinar: { id: 'campaign_pay_it_forward.referral_reward_webinar' },
  CPA_DONATION_sharing_rule: { id: 'campaign.sharing_rule_description' },
  CPC_sharing_rule: { id: 'campaign.sharing_rule_description' },
  CPA_TOKENS_sharing_rule: { id: 'campaign.sharing_rule_description' },
  CPA_WEBINAR_sharing_rule: {
    id: 'campaign_pay_it_forward.CPA_WEBINAR.sharing_rule_description',
  },
});

class NoPPCModal extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    isEmailVerificationRequired: PropTypes.bool,
    rewardsInfo: PropTypes.shape({
      arcsQuotaPerReferrer: PropTypes.number,
      businessHandle: PropTypes.string,
      campaignAddress: PropTypes.string,
      campaignType: PropTypes.string,
      currency: PropTypes.string,
      defaultValue: PropTypes.number,
      incentiveType: PropTypes.string,
      isUserJoined: PropTypes.bool,
      maximumReferralReward: PropTypes.number,
      maxValue: PropTypes.number,
      minValue: PropTypes.number,
      mustConvertToRefer: PropTypes.bool,
      refMaxValue: PropTypes.number,
      rewardsPerClick: PropTypes.number,
      status: PropTypes.string,
      value: PropTypes.number,
    }),
    referralLinks: PropTypes.object,
    isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    isMobile: PropTypes.bool,
    campaignFlowLoading: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isBusinessMode: PropTypes.bool,
    userId: PropTypes.number,
    estimatedReferralRewardLoading: PropTypes.bool,
    isOpenPayItForwardModal: PropTypes.bool,
    JOIN_CAMPAIGN: PropTypes.func.isRequired,
    OPEN_PAY_IT_FORWARD_MODAL: PropTypes.func.isRequired,
    PUSH: PropTypes.func.isRequired,
    campaign: PropTypes.object,
    enums: PropTypes.object,
    user: PropTypes.object,

    // this flag indicates how we will display component:
    // true -> as a modal;
    // false -> just as a regular piece of html
    renderWithoutModal: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    onRequestToClose: PropTypes.func,
  }

  static defaultProps = {
    renderWithoutModal: false,
    showCloseButton: false,
  };

  static contextType = AppContext;
  constructor(props) {
    super(props);
    const { search } = window.location;
    const searchParams = getSearchParams(search) || {};
    this.state = {
      editable: false,
      showHelp: false,
      cut: props.rewardsInfo.value || props.rewardsInfo.defaultValue,
      flipped: false,
      withoutMargin: !!searchParams.share_only,
    };
  }

  componentDidUpdate(prevProps) {
    const { estimatedReferralRewardLoading, rewardsInfo = {} } = this.props;
    const { rewardsInfo: prevRewardsInfo = {} } = prevProps;

    if ((!estimatedReferralRewardLoading && prevProps.estimatedReferralRewardLoading)
      || (rewardsInfo.value && prevRewardsInfo.value !== rewardsInfo.value)
      || (rewardsInfo.defaultValue && prevRewardsInfo.defaultValue !== rewardsInfo.defaultValue)) {
      this.handleChange(rewardsInfo.value || rewardsInfo.defaultValue);
    }
  }


  getCampaignAddress = () => {
    const { pathname } = window.location;

    return pathname.match(ipfsFromQuery)[0];
  }

  handleClick = () => {
    const { rewardsInfo } = this.props;
    this.setState(({ editable, cut }) => ({ editable: !editable, cut: cut || rewardsInfo.minValue }));
  }

  handleChange = cut => {
    this.setState({ cut });
  }

  toggleHelpInfo = () => {
    this.setState(({ showHelp }) => ({ showHelp: !showHelp }));
  }

  handleClose = () => {
    const {
      OPEN_PAY_IT_FORWARD_MODAL, onRequestToClose, PUSH,
    } = this.props;
    const { showHelp } = this.state;
    const { pathname, search } = window.location;
    const searchParams = getSearchParams(search) || {};

    if (searchParams.pay_forward || searchParams.share_only) {
      const newParams = { ...searchParams };
      delete newParams.pay_forward;
      TwoKeyStorage.removeItem('route');
      if (searchParams.share_only) {
        delete newParams.share_only;
        window.close();
      } else {
        PUSH(`${pathname}${setSearchParams(newParams)}`);
      }
    }
    OPEN_PAY_IT_FORWARD_MODAL(false);
    if (typeof onRequestToClose === 'function') {
      onRequestToClose();
    }
    if (showHelp) {
      this.toggleHelpInfo();
    }
  }

  handleSignAndLogin = () => {
    const { OPEN_PAY_IT_FORWARD_MODAL } = this.props;
    const { search } = window.location;
    const campaignAddress = this.getCampaignAddress();
    const searchParams = getSearchParams(search) || {};
    searchParams.pay_forward = true;
    delete searchParams.share_only;
    const route = `/${campaignAddress}${setSearchParams(searchParams)}`;

    if (route) {
      TwoKeyStorage.setItem('route', route);
    }
    OPEN_PAY_IT_FORWARD_MODAL(false);
  }

  submitUserCut = () => {
    const { editable, cut } = this.state;
    const { search } = window.location;
    const {
      rewardsInfo, JOIN_CAMPAIGN,
      userId, referralLinks,
    } = this.props;
    const campaignAddress = this.getCampaignAddress();

    if (editable) this.handleClick();

    const searchParams = getSearchParams(search);
    const fSecret = searchParams.s ? `?s=${searchParams.s}` : '';
    const referralCut = (rewardsInfo.maximumReferralReward
      ? (cut / rewardsInfo.maximumReferralReward) * 100 : 0) || (rewardsInfo.mustConvertToRefer && 13);

    if ((!referralCut || (referralCut <= 0)) && (rewardsInfo.maximumReferralReward !== 0)) {
      toast.error(formatMessage({ id: 'referral_cut_error' }));
      return;
    }

    JOIN_CAMPAIGN(
      referralLinks.twokey_from_referrer_hash
      || (campaignAddress && `${campaignAddress}${fSecret}`),
      userId,
      referralCut,
      rewardsInfo.refMaxValue
    );
  }

  handleContinueClick = () => this.setState({ flipped: true })

  isTargetAudience = () => {
    const { campaign } = this.props;
    return (!!campaign.get('targeted_audience_gender', false)
      && campaign.get('targeted_audience_gender') !== 'ANY')
      || (!!campaign.get('targeted_audience_max_age', false) && campaign.get('targeted_audience_max_age') !== 100)
      || (!!campaign.get('targeted_audience_min_age', false) && campaign.get('targeted_audience_min_age') !== 18)
      || (campaign.get('targeted_countries') && !campaign.get('targeted_countries', List()).isEmpty()
        && !(campaign.get('targeted_countries').includes('GLOBAL')
          || campaign.get('targeted_countries').includes('global')));
  }

  renderModalFooter = () => {
    const { flipped } = this.state;
    const {
      campaign, rewardsInfo, referralLinks, isLoading,
    } = this.props;

    let { isMobile } = this.props;

    // Determinate if webapp was opened from target_url embed button
    const targetUrl = campaign.get('target_url');
    const pageHash = campaign.get('cf_contractor_hash');
    if (targetUrl && pageHash) {
      const { search } = window.location;
      const searchParams = getSearchParams(search) || {};
      if (searchParams['2kp'] && searchParams['2kp'] === pageHash) {
        isMobile = isInAppBrowser();
      }
    }

    const isAuth = this.context.auth.isAuthenticated();
    const isTargetAudience = this.isTargetAudience();

    if (!isAuth) {
      return <SignAndLogin onClick={this.handleSignAndLogin} />;
    }
    if (isTargetAudience && !flipped) {
      return (
        <ActionButton
          className="continue-button"
          label={formatMessage({ id: 'main.continue' })}
          action={this.handleContinueClick}
        />
      );
    }
    return (
      <LinkGeneration
        showNotice={rewardsInfo.incentiveType === INCENTIVE_MODELS.MANUAL || rewardsInfo.mustConvertToRefer}
        isMobile={isMobile}
        referralHash={referralLinks.twokey_referrer_seed_hash && referralLinks.twokey_link}
        onSubmit={this.submitUserCut}
        arcsQuotaPerReferrer={rewardsInfo.arcsQuotaPerReferrer}
        isLoading={!!isLoading}
      />
    );
  }

  render() {
    const {
      showHelp, cut, editable, flipped, withoutMargin,
    } = this.state;
    const {
      rewardsInfo, className, isMobile, renderWithoutModal, isBusinessMode, showCloseButton, referralLinks,
      isOpenPayItForwardModal, estimatedReferralRewardLoading, campaignFlowLoading, isLoading,
      campaign, enums, isEmailVerificationRequired,
    } = this.props;
    const isActive = (renderWithoutModal || isOpenPayItForwardModal) && !estimatedReferralRewardLoading
      && (!rewardsInfo.mustConvertToRefer || rewardsInfo.isUserJoined)
      && isBusinessMode === false && !campaignFlowLoading;

    const handsGap = rewardsInfo.incentiveType === INCENTIVE_MODELS.MANUAL ?
      ((Math.abs((cut || 0) / rewardsInfo.maxValue) * -30) - 20) : -30;

    const isTargetAudience = this.isTargetAudience();

    if (!isActive || isEmailVerificationRequired) return null;

    const rewardDesc = (
      <FormattedMessage
        {...PayItForwardMessages[`${rewardsInfo.campaignType}_sharing_rule`]}
      />
    );

    const isNoRewards = rewardsInfo.incentiveType === INCENTIVE_MODELS.NO_REFERRAL_REWARD || rewardsInfo.noRewards;
    return (
      <StyledPayItForward
        className={clsx('', { [className]: className, flipped, withoutMargin })}
        isOpen={isActive}
        as={renderWithoutModal ? 'div' : Modal}
        isMobile={isMobile}
        renderWithoutModal={renderWithoutModal}
        widthNotModal
        closeTimeoutMS={100}
        onRequestClose={this.handleClose}
        showHelp={showHelp}
        type={rewardsInfo.incentiveType.toLowerCase()}
        isTargetAudience={isTargetAudience}
        overlayClassName={clsx('pay-forward', { withoutMargin })}
      >
        <section className="mirror">
          <ForwardRopstenHeader noRewards={isNoRewards} />
          {(showCloseButton || isMobile) && (
            <button className="action-close" onClick={this.handleClose}>
              <img src={CloseIcon} alt="close_white.svg" />
            </button>)}
          {!showHelp ? (
            <React.Fragment>
              <div className="top-content">
                <div className="main-bg">
                  <img src={SharingTypes[rewardsInfo.incentiveType].bgImg} alt="" />
                </div>
                <div className="relevant-rewards">
                  <img
                    src={isMobile ? LeftHandMobileIcon : LeftHandIcon}
                    alt="give_scroll.svg"
                    title="Referral Reward"
                    style={{ left: `${handsGap}px` }}
                  />
                  <img
                    src={isMobile ? RightHandMobileIcon : RightHandIcon}
                    alt="take_hand.svg"
                    title="Referral Reward"
                    style={{ right: `${handsGap}px` }}
                  />
                </div>
                <p className="title">
                  { formatMessage({ id: isNoRewards ? 'campaign_pay_it_forward.share_title' : 'main.refer_&_earn' }) }
                </p>
              </div>
              <div className="main-content">
                {!isNoRewards && (
                  <p className={`subtitle ${rewardsInfo
                    .incentiveType.toLowerCase()} ${rewardTitle[rewardsInfo.campaignType]}`}
                  >
                    <FormattedMessage
                      {...PayItForwardMessages[
                        `${rewardTitle[rewardsInfo.campaignType]}${rewardsInfo['2keyUSDRate'] ? '_hedge' : ''}`
                      ]}
                      values={{
                        reward: parseFloat((rewardsInfo.maxValue || 0).toFixed(2)),
                        rewardPerClickWithCurrency: (
                          <span className="reward-with-currency">
                            <CurrencyFormatter
                              value={rewardsInfo.rewardsPerClick - (rewardsInfo.rewardsPerClick
                                * window.CONFIG.platformFee)}
                              currency={rewardsInfo['2keyUSDRate'] ? rewardsInfo.currency : '2KEY'}
                              skipZero
                              style="short"
                            />
                          </span>
                        ),
                        type: campaignTypeHeader[rewardsInfo.campaignType],
                      }}
                    />
                  </p>)}
                <div className={`sharing-description ${rewardsInfo.incentiveType.toLowerCase()}`}>
                  {(isNoRewards) ?
                    <FormattedMessage
                      id="campaign_pay_it_forward.sharing_rule_no_reward"
                      values={{
                        here: (
                          <a
                            href="https://www.2key.network/blog-posts/launching-2key-reputation-mining-v1"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="main.here" />
                          </a>),
                      }}
                    /> : rewardDesc}
                  {!isNoRewards && (
                    <button className="how-it-works" onClick={this.toggleHelpInfo}>
                      <FormattedMessage id="main.how_it_works?" />
                    </button>)}
                </div>
                {(isTargetAudience && !flipped) &&
                  <TargetAudience
                    gender={campaign.get('targeted_audience_gender', '').toLowerCase()}
                    minAge={campaign.get('targeted_audience_min_age', 0)}
                    maxAge={campaign.get('targeted_audience_max_age', 0) !== 120
                      ? campaign.get('targeted_audience_max_age', 0)
                      : 0}
                    countries={campaign.get('targeted_countries', List())}
                    enumsCountries={enums.Country.Country.name_to_value}
                  />
                }
                {isNoRewards && (
                  <div className="no-rewards-terms">
                    <FormattedMessage id="campaign_pay_it_forward.rewards_are_subject" />
                    &nbsp;
                    <a href={window.CONFIG.termsUrl} target="_blank" rel="noopener noreferrer">
                      <FormattedMessage id="main.terms_&_conditions" />
                    </a>
                  </div>)}
                {!isNoRewards && (
                  <div className="sharing-type">
                    <p className="type-name">
                      {formatMessage(PayItForwardMessages[`${rewardsInfo.incentiveType.toLowerCase()}_title`])}
                    </p>
                    <div className="type-img">
                      <img src={SharingTypes[rewardsInfo.incentiveType].img} alt="" />
                    </div>
                    <div className="type-description-wrap">
                      <span className={`type-description-text ${rewardsInfo.incentiveType.toLowerCase()}`}>
                        {formatMessage(PayItForwardMessages[`${rewardsInfo.incentiveType.toLowerCase()}_description`])}
                      </span>
                    </div>
                    {rewardsInfo.incentiveType === 'MANUAL' && (
                      <ManualReward
                        isMobile={isMobile}
                        value={cut}
                        max={rewardsInfo.maxValue}
                        step={0.1}
                        min={rewardsInfo.minValue}
                        editable={editable}
                        mustConvertToRefer={rewardsInfo.mustConvertToRefer}
                        disabled={!!(rewardsInfo.value || referralLinks.twokey_referrer_seed_hash)
                          || !!isLoading || (rewardsInfo.mustConvertToRefer && !rewardsInfo.isUserJoined)}
                        onChange={this.handleChange}
                        toggleEditMode={this.handleClick}
                      />)}
                  </div>)}
              </div>
            </React.Fragment>) :
            (<HowItWorks
              isMobile={isMobile}
              onClose={this.handleClose}
              onBack={this.toggleHelpInfo}
              bgImg={SharingTypes[rewardsInfo.incentiveType].bgImg}
            />)}
          {this.renderModalFooter()}
        </section>
      </StyledPayItForward>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoPPCModal);
